import { ArrowRight } from 'lucide-react';
import { FC } from 'react';

interface CloseFiltersButtonProps {
  onCloseFilters: () => void;
  inOpen: boolean;
}

const CloseFiltersButton: FC<CloseFiltersButtonProps> = ({
  onCloseFilters,
  inOpen
}) => (
  <button
    type="button"
    title="Cerrar filtros"
    onClick={onCloseFilters}
    className="inline-flex h-9 w-9 items-center justify-center rounded-full text-inkMuted transition hover:scale-110 hover:text-secondary-600 dark:text-inkMuted-dark dark:hover:text-secondary-300"
  >
    <ArrowRight
      size={18}
      className="transition-transform"
      style={{ transform: `rotate(${inOpen ? 0 : 180}deg)` }}
    />
  </button>
);

export default CloseFiltersButton;
